import React from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import {handleBoxNavigation} from '../../actions/scanpackScanningActions';
import useMultiBoxState from './hooks/useMultiBoxState';

const MobileMultiBoxBar = ({scannedList, unScannedList, showUnScannedListTab}) => {
  const {
    dispatch,
    currentOrder,
    activeBoxIndex,
    multiBox,
    showBoxUi,
    boxes,
    boxOfCount,
    boxScannedCount,
    boxName,
    handlePrintSlip
  } = useMultiBoxState();

  const scannedItems = currentOrder?.scanned_items || [];

  if (!showBoxUi || scannedItems.length === 0) return null;

  return (
    <View
      testID="multiBox"
      style={{
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginHorizontal: 10,
        padding: 5,
      }}>
      {multiBox && (
        <TouchableOpacity
          testID="goPrevIcon"
          onPress={() => dispatch(handleBoxNavigation('prev'))}>
          <i
            className="icon-up-open"
            style={{
              color: 'white',
              transform: 'rotate(270deg)',
              visibility: activeBoxIndex <= 0 ? 'hidden' : 'visible',
              fontSize: 21,
            }}></i>
        </TouchableOpacity>
      )}

      <View style={{flex: 1, alignItems: 'center', marginHorizontal: 6}}>
        <TouchableOpacity onPress={showUnScannedListTab}>
          {scannedList ? (
            <Text style={{color: 'white', fontSize: 17, textAlign: 'center'}}>
              {boxName} is Active
            </Text>
          ) : (
            <Text style={{color: 'white', fontSize: 17, textAlign: 'center'}}>
              {boxScannedCount} of {boxOfCount} Scanned Items in {boxName}
            </Text>
          )}
        </TouchableOpacity>
      </View>

      {multiBox && unScannedList && (
        <TouchableOpacity
          testID="printSlip"
          style={{marginRight: 12}}
          onPress={handlePrintSlip}>
          <i className="icon-print" style={{fontSize: 18, color: 'white'}}></i>
        </TouchableOpacity>
      )}

      {multiBox && (activeBoxIndex >= boxes.length - 1 ? (
        <TouchableOpacity
          testID="addBoxIcon"
          onPress={() => dispatch(handleBoxNavigation('next'))}>
          <i className="icon-plus" style={{color: 'white', fontSize: 25}}></i>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          testID="goNextIcon"
          onPress={() => dispatch(handleBoxNavigation('next'))}>
          <i
            className="icon-up-open"
            style={{color: 'white', fontSize: 25, transform: 'rotate(90deg)'}}></i>
        </TouchableOpacity>
      ))}
    </View>
  );
};

export default MobileMultiBoxBar;
